<app-layout-page>
  <app-layout-header>
  </app-layout-header>

  <app-layout-content>
    <img src="/assets/image/graphic/microphone-access.svg" alt="" class="large-icon">

    <h2 trans="voice_check.media_error.title"></h2>

    <p trans="voice_check.media_error.p1"></p>
  </app-layout-content>

  <app-layout-buttons>
    <button class="btn btn-primary pull-center next" (click)="refresh()" trans="voice_check.media_error.button"></button>
    @if (showBrowserProblemLink) {
      <app-browser-problem-link></app-browser-problem-link>
    }
  </app-layout-buttons>

</app-layout-page>
